import React from "react"
import styled, { css } from "styled-components"
import { baseRoutes, routeBasenames } from "routes"

import { ParagraphSmall, PlainLink as _PlainLink, Link as _Link } from "components/text"
import { PHONE_NUMBER } from "components/support-links"
import { Flex } from "components/box"

const Container = styled(Flex)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;

  align-items: stretch;
`
const linkCSS = css`
  color: ${props => props.theme.colors.evergreen};
  font-family: ${props => props.theme.fonts.paragraph};
  line-height: 1.55;
  font-size: 14px;
  text-decoration: none;
`

const PlainLink = styled(_PlainLink)`
  ${linkCSS}
`

const Link = styled(_Link)`
  ${linkCSS}
  font-weight: bold;
`

const MobileHiddenFlex = styled(Flex)`
  display: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    display: flex;
    align-items: center;
  }
`

const YellowContainer = styled(Flex)`
  align-items: center;
  height: 100%;
  background-color: ${props => props.theme.colors.sandy};
`

const RightNavigationPanel = () => (
  <Container>
    <MobileHiddenFlex>
      <Flex mr={6}>
        <ParagraphSmall bold>Need help?</ParagraphSmall>
        <PlainLink href={`tel:${PHONE_NUMBER}`} ml={1}>
          {PHONE_NUMBER}
        </PlainLink>
      </Flex>
      <Link to={baseRoutes.signIn()}>Sign In</Link>
    </MobileHiddenFlex>
    <YellowContainer px={[4, 4, 6, 6]} ml={6}>
      <Link to={routeBasenames.purchase}>Get Started</Link>
    </YellowContainer>
  </Container>
)

export default RightNavigationPanel
